// src/features/settings/SettingsPage.tsx
import { useAuthStore } from '@vanialabs/core-auth';
import { ProfileCard } from './components/ProfileCard';
import { RepresentativeMetricsSection } from './components/RepresentativeMetricsSection';
import { RepresentativeUsersSection } from './components/RepresentativeUsersSection';
import './styles/settings.css';

export function SettingsPage() {
  const representativeName = useAuthStore((state) => state.session?.user.name);

  return (
    <div className="representative-profile-page">
      {representativeName ? (
        <div className="representative-profile-page__surface representative-profile-page__surface--identity-only">
          <ProfileCard name={representativeName} />
        </div>
      ) : null}

      <RepresentativeMetricsSection />
      <RepresentativeUsersSection />
    </div>
  );
}
